import { componentTwo, componentOne } from './components';
componentOne();
componentTwo();